import { ActionIcon, Tooltip } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';

import { useT } from '../i18n';

/**
 * PRE-125: this content is authored in the repository, not here.
 *
 * A lock rather than a hidden control, and a named file rather than a shrug.
 * Hiding the button would leave a product owner hunting for an editor that used
 * to exist; leaving it enabled would be worse still, because the API refuses the
 * write and the panel would be offering an action that cannot succeed. Saying
 * where the text lives is the only version of this that respects the person
 * standing in front of it.
 *
 * The API is the actual enforcement (`seeded-content.ts` — it answers 409 with
 * this same path). This is the courtesy on top: nobody should have to discover a
 * rule by triggering an error.
 */
export function SeededLock({ file, what }: { file: string; what: string }) {
  const t = useT();
  return (
    <Tooltip withArrow multiline w={320} label={t('seededLock.tooltip', { what, file })}>
      <ActionIcon variant="subtle" color="gray" aria-label={t('seededLock.aria', { what, file })}>
        <IconLock size={16} />
      </ActionIcon>
    </Tooltip>
  );
}

/** Repo paths, kept next to the component that shows them. */
export const SEEDED_FILES = {
  businessRules: 'packages/db/seed/content/product-document/business-rules.ts',
  steps: 'packages/db/seed/content/product-document/blueprint-steps.ts',
  rules: 'packages/db/seed/content/product-document/blueprint-rules.ts',
} as const;
